__webpack_require__.p = "https://mprod.d12dvpsxvwz2ny.amplifyapp.com/";